/**
 * @description Main container for the Company > Time Off tab
 *
 * Key features:
 * - Manages PTO requests and employee balances
 * - Sub-tabs: Pending | All Requests | Balances
 * - Approve/deny requests, adjust balances
 * - refreshKey remounts/reloads list after Create → Time Off Request modal success
 *
 * @dependencies
 * - PtoRequestList: PTO request management component
 */

import React from 'react';
import PtoRequestList from '../scheduling/PtoRequestList';

const CompanyTimeOffTab = ({ refreshKey = 0 }) => {
  return (
    <div className="space-y-4">
      <PtoRequestList refreshKey={refreshKey} />
    </div>
  );
};

export default CompanyTimeOffTab;
